exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gap {\n  position: relative;\n  width: 100%;\n  height: 100%; }\n  .gap.flex-container {\n    -ms-flex-pack: center;\n        justify-content: center; }\n  .gap i {\n    font-size: 34px; }\n\nimg {\n  display: block; }\n\n@media (min-width: 320px) and (max-width: 480px) {\n  img {\n    width: 100%; } }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/programming/Чижик_Api_Site_Sources-Electroline/front/src/app/common/img.component.scss
// module id = ../../../../../src/app/common/img.component.scss
// module chunks = main